import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faCheckSquare, faFileText } from '@fortawesome/free-solid-svg-icons';
import { DocumentItem } from './DocumentItem';
import { DocumentoItem, ChecklistItem } from '../types';

interface ChecklistProps {
  itens: DocumentoItem[];
  onAddItem: () => void;
  onUpdateItem: (id: string, field: keyof DocumentoItem, value: string) => void;
  onRemoveItem: (id: string) => void;
  onGenerateChecklist: () => void;
  checklistGerado: ChecklistItem[];
}

export const Checklist: React.FC<ChecklistProps> = ({
  itens,
  onAddItem,
  onUpdateItem,
  onRemoveItem,
  onGenerateChecklist,
  checklistGerado,
}) => {
  return (
    <div className="card checklist">
      <div className="card-header">
        <FontAwesomeIcon icon={faCheckSquare} className="card-icon" size={24} />
        <h2>Checklist de Documentos</h2>
      </div>
      
      <div className="checklist-content">
        {itens.length === 0 ? (
          <div className="empty-state">
            <FontAwesomeIcon icon={faFileText} className="empty-icon" size={48} />
            <p>Nenhum documento adicionado ainda</p>
            <p className="empty-subtitle">Clique em "Adicionar Documento" para começar</p>
          </div>
        ) : (
          <div className="document-list">
            {itens.map((item) => (
              <DocumentItem
                key={item.id}
                item={item}
                onUpdate={onUpdateItem}
                onRemove={onRemoveItem}
              />
            ))}
          </div>
        )}
        
        <div className="checklist-actions">
          <button
            type="button"
            onClick={onAddItem}
            className="btn btn-secondary"
          >
            <FontAwesomeIcon icon={faPlus} size={20} />
            Adicionar Documento
          </button>
          
          {itens.length > 0 && (
            <button
              type="button"
              onClick={onGenerateChecklist}
              className="btn btn-primary"
            >
              <FontAwesomeIcon icon={faCheckSquare} size={20} />
              Gerar Checklist
            </button>
          )}
        </div>
      </div>
      
      {checklistGerado.length > 0 && (
        <div className="checklist-result">
          <h3>Checklist Gerado:</h3>
          <ul className="checklist-list">
            {checklistGerado.map((item, index) => (
              <li key={index} className="checklist-item">
                ☐ {item.texto}
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};
